module.exports = __webpack_public_path__ + "static/google_store@3x.3ed10a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/google_store@3x.jpg
// module id = 223
// module chunks = 193162123475590 216210090109534